import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const transportForIreland = defineConnector({
  identifier: "transportForIreland",
  name: "Transport for Ireland",
  tagLine: "Irish public transport schedules and realtime updates",
  keywords: "nta national transport authority gtfs gtfs-r dublin bus éireann",
  logo,
  protocol: "http",
  tags: ["data", "travel"],
  defaultUrlPattern: () => domainToRegex("api.nationaltransport.ie"),
  auth: (app) =>
    headerAuth([{ name: "x-api-key", value: app.secret.subscriptionKey }]),
  steps: [
    {
      title: "Subscribe to a data product",
      items: [
        {
          kind: "markdown",
          content:
            "Sign up at the [**NTA developer portal**](https://developer.nationaltransport.ie/), then subscribe to the **GTFS-Realtime** product. Open your profile to reveal the subscription’s primary key.",
        },
      ],
    },
    {
      title: "Copy and paste the subscription key into the field below",
      items: [
        {
          kind: "input",
          label: "Subscription key",
          required: true,
          target: { kind: "secrets", field: "subscriptionKey" },
          helperText:
            "The primary key of your product subscription. Realtime feeds cover Dublin Bus, Bus Éireann, and Go-Ahead Ireland.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () =>
      "https://api.nationaltransport.ie/gtfsr/v2/Alerts?format=json",
  },
});
